/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SubmitterModel } from './SubmitterModel';
import {
    SubmitterModelFromJSON,
    SubmitterModelFromJSONTyped,
    SubmitterModelToJSON,
} from './SubmitterModel';

/**
 * 
 * @export
 * @interface PetTypeModel
 */
export interface PetTypeModel {
    /**
     * 
     * @type {number}
     * @memberof PetTypeModel
     */
    id: number;
    /**
     * 
     * @type {SubmitterModel}
     * @memberof PetTypeModel
     */
    submitter?: SubmitterModel;
    /**
     * 
     * @type {string}
     * @memberof PetTypeModel
     */
    name?: string;
    /**
     * Only modifiable during update.
     * @type {boolean}
     * @memberof PetTypeModel
     */
    markForDelete?: boolean;
    /**
     * System assigned. Not modifiable during creation or update.
     * @type {boolean}
     * @memberof PetTypeModel
     */
    pharmacyEligible?: boolean;
    /**
     * System assigned. Not modifiable during creation or update.
     * @type {boolean}
     * @memberof PetTypeModel
     */
    vetDietEligible?: boolean;
}

/**
 * Check if a given object implements the PetTypeModel interface.
 */
export function instanceOfPetTypeModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function PetTypeModelFromJSON(json: any): PetTypeModel {
    return PetTypeModelFromJSONTyped(json, false);
}

export function PetTypeModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetTypeModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'submitter': !exists(json, 'submitter') ? undefined : SubmitterModelFromJSON(json['submitter']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'markForDelete': !exists(json, 'markForDelete') ? undefined : json['markForDelete'],
        'pharmacyEligible': !exists(json, 'pharmacyEligible') ? undefined : json['pharmacyEligible'],
        'vetDietEligible': !exists(json, 'vetDietEligible') ? undefined : json['vetDietEligible'],
    };
}

export function PetTypeModelToJSON(value?: PetTypeModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'submitter': SubmitterModelToJSON(value.submitter),
        'name': value.name,
        'markForDelete': value.markForDelete,
        'pharmacyEligible': value.pharmacyEligible,
        'vetDietEligible': value.vetDietEligible,
    };
}

